import React, { FC, KeyboardEvent, useCallback } from 'react';


import Modal from 'js/components/modals/Modal';
import {
  PremiumReaderProductsModal,
  Props,
} from 'js/bulk_download/reader_products_modal/premium_reader_products_modal';
import _styles from "BulkDownloadModal-styles.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/News/BulkDownloadModal.tsx?styleId=styles";


const styles = _styles;

const BulkDownloadModal: FC<Props> = (props) => {
  const { closeModal } = props;
  const closeModalOnEscape = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    },
    [closeModal],
  );

  return (
    <Modal
      backdropClassName={styles.backdrop}
      className={styles.modal}
      onClose={closeModal}
      containerProps={{
        onKeyDown: closeModalOnEscape,
      }}
    >
      <PremiumReaderProductsModal {...props} />
    </Modal>
  );
};

export default BulkDownloadModal;
